import Vue from 'vue'
import ElementUI from '@lui/lui-ui'
import '@lui/lui-ui/lib/theme-chalk/index.css'
import App from 'pages/national/App.vue'
import VueClipboard from 'vue-clipboard2'
import dayjs from 'dayjs'
import microApp, { getActiveApps } from '@micro-zoe/micro-app'
import store from '@/store'
import router from '@/router/national/index'
import i18n from '@/locales/index'
import 'pages/national/public-path.js'
import envConfig from '@/env/index.js'
import { injectCsat, setCsatLanguage } from '@/env/csat.js'

injectCsat(envConfig)

// 系统语言切换时同步 CSAT 语言
store.subscribe((mutation) => {
  if (mutation.type === 'user/SET_LOCALE') {
    setCsatLanguage(mutation.payload)
  }
})

import '@/components/lemon-imui/dist/index.css'

import LemonIMUI from '@/components/lemon-imui/packages/index'

Vue.use(LemonIMUI)
Vue.component(LemonMessageBox.name, LemonMessageBox)

import LemonMessageBox from "@/components/toTop/inToTop/components/lemonMessageBox.vue";
Vue.component(LemonMessageBox.name, LemonMessageBox);

Vue.use(ElementUI, { i18n: (key: any, value: any) => i18n.t(key, value) });
Vue.use(VueClipboard);
Vue.config.devtools = true;

Vue.prototype.$dayjs = dayjs

if (
  sessionStorage.getItem('store') &&
  sessionStorage.getItem('store') != null
) {
  store.replaceState(
    Object.assign(
      {},
      store.state,
      JSON.parse(<string>sessionStorage.getItem("store"))
    )
  );
}

// const site = localStorage.getItem("site");
const locale = localStorage.getItem("locale") || 'zh-cn';
// site && store.commit("SET_SITE", site);
locale && store.commit("SET_LOCALE", locale);

// 更新站点信息
// store.dispatch('UPDATE_SITE_FROM_PATHNAME');

window.addEventListener('beforeunload', () => {
  sessionStorage.setItem('store', JSON.stringify(store.state))
})
window.env = envConfig
window.microPushStatus = microPushStatus

startMicro()
new Vue({
  router,
  store,
  i18n,
  render: (h: (arg0: any) => any) => h(App),
}).$mount('#lcp_vue_web')

function startMicro() {
  microApp.start({
    tagName: 'micro-app-lcp-vue-web',
  })
}
if (window.__MICRO_APP_ENVIRONMENT__) {
  // 作为子应用运行,可以在此处添加一些父子应用通信的事件
  addDataListener()
}
function microPushStatus(path: string, routeName: string) {
  if (!getActiveApps().includes('lcp_vue_web_upgrade')) {
    router.push({ path })
  } else {
    microApp.setData('lcp_vue_web_upgrade', { path, routeName })
  }
}

function addDataListener() {
  window.microApp.addDataListener((e: any) => {
    console.log(
      '子应用收到基座跳转路由通知开始跳转路由',
      e.routeName,
      router.push
    )
    if (e.routeName) {
      router.push({ name: e.routeName })
    }
  })
}
